// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

.hiddenContainer {
  width: 100%;
}
.hiddenContainer .toggle-button {
  cursor: pointer;
  border: unset;
  background-color: unset;
  padding: 10px;
  width: calc(3em + 20px);
  height: calc(0.2em + 20px);
  border: unset;
  background-color: unset;
  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}
.hiddenContainer .toggle-inner {
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  opacity: 0.5;
  background-color: rgb(168, 168, 168);
  color: rgb(168, 168, 168);
  height: 0.2em;
  width: 3em;
  display: flex;
  justify-content: center;
  flex-grow: 1;
  font-size: 0.9em;
  border-radius: 2px;
}
.hiddenContainer .toggle-inner span {
  display: block;
  flex-grow: 1;
  margin-top: -1px;
}
.hiddenContainer .toggle-button:hover .toggle-inner,
.hiddenContainer .toggle-inner:hover {
  transform: scale(1.1);
  opacity: 1;
}
.hiddenContainer .content {
  opacity: 0;
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}
.hiddenContainer .content.show {
  opacity: 1;
}

.hiddenVerticalContainer {
  position: relative;
}
.hiddenVerticalContainer .toggle-tooltip {
  position: absolute;
  top: calc(50% - 27px);
  left: -2.85rem;
  transition: transform 0.1s ease;
  transform: rotate(90deg);
}
.hiddenVerticalContainer .toggle-tooltip:hover {
  transform: scale(1.1) rotate(90deg);
}
.hiddenVerticalContainer .toggle-button {
  cursor: pointer;
  padding: 0px 10px 15px 10px;
  width: calc(3em + 20px);
  height: calc(0.2em + 20px);
  border: unset;
  background-color: unset;
}
.hiddenVerticalContainer .toggle-inner {
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  opacity: 0.5;
  background-color: rgb(168, 168, 168);
  color: rgb(168, 168, 168);
  height: 0.2em;
  width: 3em;
  display: flex;
  justify-content: center;
  flex-grow: 1;
  font-size: 0.9em;
  border-radius: 2px;
}
.hiddenVerticalContainer .toggle-inner span {
  display: block;
  flex-grow: 1;
  margin-top: -1px;
}
.hiddenVerticalContainer .toggle-button:hover .toggle-inner,
.hiddenVerticalContainer .toggle-inner:hover {
  opacity: 1;
}
.hiddenVerticalContainer .content {
  width: 0;
  opacity: 0;
  transition: max-height 0.5s ease-in-out, width 0.3s ease-in-out, opacity 0.5s ease-in-out;
}
.hiddenVerticalContainer .content.show {
  opacity: 1;
  width: 100%;
  height: 100%;
}

.hiddenContainerPulse {
  animation: pulseHiddenContainerBtn 1.5s 2 ease-out;
}
@keyframes pulseHiddenContainerBtn {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.75);
  }
  50% {
    transform: scale(1.25);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/App/vars.scss","webpack://./src/Components/conteiners/hiddenContainer/hiddenContent.scss"],"names":[],"mappings":"AA8CA;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;AC7CF;;AAHA;EACE,WAAA;AAMF;AAJE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,wDAAA;AAMJ;AAHE;EACE,eAAA;EACA,wDAAA;EACA,YAAA;EACA,oCAAA;EACA,yBAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAKJ;AAHI;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AAKN;AADE;;EAEE,qBAAA;EACA,UAAA;AAGJ;AADE;EACE,UAAA;EACA,iEAAA;AAGJ;AAAE;EAEE,UAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;AAEE;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,+BAAA;EACA,wBAAA;AAAJ;AAEI;EACE,mCAAA;AAAN;AAIE;EACE,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;AAFJ;AAKE;EACE,eAAA;EAEA,wDAAA;EACA,YAAA;EACA,oCAAA;EACA,yBAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AAJN;AAQE;;EAEE,UAAA;AANJ;AAQE;EACE,QAAA;EACA,UAAA;EACA,yFAAA;AANJ;AASE;EAEE,UAAA;EACA,WAAA;EACA,YAAA;AARJ;;AAYA;EAkBE,kDAAA;AA1BF;AASE;EACE;IACE,mBAAA;EAPJ;EASE;IACE,sBAAA;EAPJ;EASE;IACE,sBAAA;EAPJ;EASE;IACE,sBAAA;EAPJ;EASE;IACE,mBAAA;EAPJ;AACF","sourcesContent":["$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$borderColorLight: #dae1ec;\n$accentFilterColor: #ff8040;\n$accentColor: #b72025;\n$warningColor: #d3c71c;\n$succesColor: #00dbbb;\n$accentTableRowColor: #ecc0c1;\n$filtersBgColor: #d6dfea71; //#d6dfea\n$filterTitleColor: #d6dfea93;\n$textColor: #426ba6;\n$filtersBorderColor: #426ba6;\n$deletedTextColor: #b72025;\n$iconFill: #829ec4;\n$logoIcon: #6d91c6;\n$activeBtnColor: rgba(218, 225, 236, 1);\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n$btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;\n$reactTableShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;\n$dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;\n$commonShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$commonShadowHover: rgba(67, 71, 85, 0.27) 1px 1px 0.25em, rgba(90, 125, 188, 0.05) 1px 0.3em 1em;\n\n$transition: ease;\n$transitionFunc: cubic-bezier(0.25, 1, 0.5, 1);\n$iconHoverTransition: cubic-bezier(0.22, 1, 0.36, 1);\n$commonTransition: 0.3s $transitionFunc;\n\n:root {\n  --filterBtnBoxShadow: #{$filterBtnBoxShadow};\n  --btnBoxShadow: #{$btnBoxShadow};\n  --btnHoverBoxShadow: #{$btnHoverBoxShadow};\n  --dividerShadow: #{$dividerShadow};\n}\n\n$main-font: \"Roboto\", sans-serif;\n\n$font-weights: (\n  \"Light\": 300,\n  \"Regular\": 400,\n  \"Medium\": 500,\n  \"Bold\": 700,\n);\n","@import \"../../../Components/App/vars.scss\";\n\n.hiddenContainer {\n  width: 100%;\n\n  .toggle-button {\n    cursor: pointer;\n    border: unset;\n    background-color: unset;\n    padding: 10px;\n    width: calc(3em + 20px);\n    height: calc(0.2em + 20px);\n    border: unset;\n    background-color: unset;\n    transition: transform $commonTransition;\n  }\n\n  .toggle-inner {\n    cursor: pointer;\n    transition: transform $commonTransition;\n    opacity: 0.5;\n    background-color: rgb(168, 168, 168);\n    color: rgb(168, 168, 168);\n    height: 0.2em;\n    width: 3em;\n    display: flex;\n    justify-content: center;\n    flex-grow: 1;\n    font-size: 0.9em;\n    border-radius: 2px;\n\n    span {\n      display: block;\n      flex-grow: 1;\n      margin-top: -1px;\n    }\n  }\n\n  .toggle-button:hover .toggle-inner,\n  .toggle-inner:hover {\n    transform: scale(1.1);\n    opacity: 1;\n  }\n  .content {\n    opacity: 0;\n    transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;\n  }\n\n  .content.show {\n    // max-height: 500px; /* Достаточно большое значение */\n    opacity: 1;\n  }\n}\n\n.hiddenVerticalContainer {\n  position: relative;\n\n  .toggle-tooltip {\n    position: absolute;\n    top: calc(50% - 27px);\n    left: -2.85rem;\n    transition: transform 0.1s ease;\n    transform: rotate(90deg);\n\n    &:hover {\n      transform: scale(1.1) rotate(90deg);\n    }\n  }\n\n  .toggle-button {\n    cursor: pointer;\n    padding: 0px 10px 15px 10px;\n    width: calc(3em + 20px);\n    height: calc(0.2em + 20px);\n    border: unset;\n    background-color: unset;\n  }\n\n  .toggle-inner {\n    cursor: pointer;\n\n    transition: transform $commonTransition;\n    opacity: 0.5;\n    background-color: rgb(168, 168, 168);\n    color: rgb(168, 168, 168);\n    height: 0.2em;\n    width: 3em;\n    display: flex;\n    justify-content: center;\n    flex-grow: 1;\n    font-size: 0.9em;\n    border-radius: 2px;\n\n    span {\n      display: block;\n      flex-grow: 1;\n      margin-top: -1px;\n    }\n  }\n\n  .toggle-button:hover .toggle-inner,\n  .toggle-inner:hover {\n    opacity: 1;\n  }\n  .content {\n    width: 0;\n    opacity: 0;\n    transition: max-height 0.5s ease-in-out, width 0.3s ease-in-out, opacity 0.5s ease-in-out;\n  }\n\n  .content.show {\n    // max-height: 500px; /* Достаточно большое значение */\n    opacity: 1;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.hiddenContainerPulse {\n  @keyframes pulseHiddenContainerBtn {\n    0% {\n      transform: scale(1);\n    }\n    25% {\n      transform: scale(0.75);\n    }\n    50% {\n      transform: scale(1.25);\n    }\n    75% {\n      transform: scale(0.75);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n  animation: pulseHiddenContainerBtn 1.5s 2 ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
